import React from 'react';
import { Placeholder, Col } from '@thd-olt-component-react/core-ui';
import './FBRPlaceholder.scss';

export const FBRPlaceholder = () => (
  <Col className="fbr-placeholder" data-component="FBRPlaceholder">
    <div className="fbr-placeholder__heading">
      <Placeholder height="100%" width="100%" />
    </div>
    <div className="fbr-placeholder__body">
      {new Array(5).fill('').map((__, key) => (
        <div key={`section-${key}`} className="fbr-placeholder__body-section">
          <Placeholder type="text" height="100%" />
        </div>
      ))}
    </div>
  </Col>
);

FBRPlaceholder.displayName = 'FBRPlaceholder';
